import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../Views/SafcoDashboard.vue'
import Tables from '../Views/SafcoTables.vue'
import InputData from '../Views/SafcoInputData.vue'
import Factura from '../Views/FacturasCopec.vue'
import Login from '../Views/SafcoLogin.vue'
import { authStore } from '@/stores/authStore.js'

const routes = [
  { path: '/login', name: 'Login', component: Login, meta: { publica: true } },
  { path: '/', name: 'Dashboard', component: Dashboard },
  { path: '/tables', name: 'Tables', component: Tables },
  { path: '/input-data', name: 'InputData', component: InputData },
  { path: '/factura', name: 'Factura', component: Factura }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// ===============================
// 🔒 Guard de sesión
// ===============================
// Consulta /auth/me una sola vez y reutiliza el resultado.
// Sin sesión no se monta ninguna vista que pida datos.
router.beforeEach(async (to) => {
  await authStore.cargarSesion()

  if (to.meta.publica) {
    // Quien ya tiene sesión no necesita volver a entrar.
    return authStore.autenticado ? { path: '/' } : true
  }

  if (!authStore.autenticado) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  return true
})

export default router
